import { CircularProgress, Stack, styled } from '@mui/material';

export const DisabledVStack = styled(Stack)`
  &.disabled {
    pointer-events: none;
  }
  flex-grow: 1;
`;

export const Spinner = styled(CircularProgress)`
  position: absolute;
  right: 9px;
`;
